import { OrganizationSelector } from "@/components/OrganizationSelector";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Suspense } from "react";
import { Link } from "react-router-dom";
import { User } from "../gen/rbt/cloud/v1alpha1/user/user_rbt_react";
import rebootCloud from "/reboot-cloud.svg";

interface HeaderProps {
  userState: User.State | undefined;
  onSignOut?: () => void;
  organizationIds?: string[];
  currentOrganizationId?: string;
  onOrganizationChange?: (organizationId: string) => void;
}

export function Header({
  userState,
  onSignOut,
  organizationIds,
  currentOrganizationId,
  onOrganizationChange,
}: HeaderProps) {
  const userInitials = userState?.email?.[0]?.toUpperCase() ?? "?";

  return (
    <header className="h-16 border-b bg-background">
      <div className="h-full px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src={rebootCloud} alt="Reboot Cloud" className="h-8" />
        </Link>
        <div className="flex items-center gap-3">
          <Button asChild variant="outline">
            <a
              href="https://docs.reboot.dev"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get started
            </a>
          </Button>
          <Suspense
            fallback={
              <div className="px-2 py-1 text-sm text-muted-foreground">
                Loading...
              </div>
            }
          >
            <OrganizationSelector
              organizationIds={organizationIds ?? []}
              currentOrganizationId={currentOrganizationId}
              onOrganizationChange={onOrganizationChange}
            />
          </Suspense>
          <Sheet>
            <SheetTrigger asChild>
              <Avatar className="cursor-pointer">
                <AvatarFallback className="bg-primary text-secondary font-bold">
                  {userInitials}
                </AvatarFallback>
              </Avatar>
            </SheetTrigger>
            <SheetContent>
              <SheetTitle className="sr-only">User Menu</SheetTitle>
              <SheetDescription className="sr-only">
                View your account details and logout
              </SheetDescription>
              <div className="flex flex-col gap-4 mt-8">
                <div>
                  <div className="text-sm text-muted-foreground">
                    {userState?.email}
                  </div>
                </div>
                <Button variant="secondary" onClick={onSignOut}>
                  Logout
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
